import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';

import CustomTeamImageWithDefault from '@/components/shared/custom/CustomTeamImageWithDefault';

const FixtureCardsPerMinutes = ({ fixturePrediction, includeHome, includeAway }) => {
    const home = fixturePrediction.teams.home;
    const away = fixturePrediction.teams.away;

    const getTeamTitle = (team) => {
        return (
            <div style={{ display: 'flex', gap: '5px', alignItems: 'center' }}>
                <CustomTeamImageWithDefault
                    teamId={team.id}
                    alt={team.name}
                    width={20}
                    height={20}
                ></CustomTeamImageWithDefault>
                <span>{team.name}</span>
            </div>
        );
    };

    const getTotal = (cards) => {
        let suma = 0;

        for (const clave in cards) {
            if (cards.hasOwnProperty(clave) && cards[clave].total !== null) {
                const totalComoNumero = parseFloat(cards[clave].total);
                if (!isNaN(totalComoNumero)) {
                    suma += totalComoNumero;
                }
            }
        }

        return suma;
    };

    const getTable = (team) => {
        return (
            <TableContainer component={Paper} className="datos-table-container mb-25">
                <Table className="data-table-cards-per-minutes" size={'small'} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell className="first-row title-tabs">{getTeamTitle(team)}</TableCell>
                            <TableCell className="table-row text"></TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className="first-row" style={{ fontWeight: '600' }}>
                                Tarjetas
                            </TableCell>
                            <TableCell className="table-row" style={{ fontWeight: '600' }}>
                                Total
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                            <TableCell className="first-row">Tarjetas amarillas</TableCell>
                            <TableCell className="table-row">{getTotal(team.league.cards.yellow)}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className="first-row">Tarjetas rojas</TableCell>
                            <TableCell className="table-row">{getTotal(team.league.cards.red)}</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
        );
    };

    return (
        <div className="fixture-predictions-container">
            {includeHome && getTable(home)}
            {includeAway && getTable(away)}
        </div>
    );
};

export default FixtureCardsPerMinutes;
